import React from 'react';
import NewFileUpload from '../../forms/NewFileUpload';
import { showErrorInfo } from '../../forms/newFields';

export function PureFileField({ label, mandatory, disabled, ...props }) {
  return (
    <div className="scope-field-container">
      <NewFileUpload label={label} mandatory={mandatory} disabled={disabled} {...props} />
      {showErrorInfo(props)}
    </div>
  );
}

